export function appendSolo() {
    const triggers = document.querySelectorAll('[data-solo-trigger]');
    const appendStatus = document.querySelector('[data-append]');

    for (const trigger of triggers) {
        const id = trigger.dataset.soloTrigger;

        trigger.addEventListener('click', () => {
            if (appendStatus.dataset.append === id) {
                appendStatus.dataset.append = 'all';
                return;
            }
            appendStatus.dataset.append = id;
        });
    }
}
